<template lang="pug">
  #victim
    v-container.no-p.grey-container(fluid)
      v-form
        v-layout.py-0.my-0(row wrap justify-end)
          v-flex.upload(d-flex sm6 xs12)
            p.bold.underline(@click="pickFile") Cargar fotografía
              span.ml-2
                font-awesome-icon(icon="upload" size="lg")
            input(
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="uploadPicture"
            )
          v-flex.upload.px-3(d-flex xs12 sm6)
            p.small.underline.dark-text.text-xs-right(@click="deletePhoto()") Eliminar fotografía
        v-layout.py-0.my-0(row wrap justify-between)
          v-flex.pr-2(d-flex xs12)
            v-text-field(
              v-model="victimName"
              ref="Nombre de la víctima"
              label="Nombre de la víctima"
              menu-props="auto"
            )
        v-layout.py-0.my-0(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-text-field(
              v-model="victimNationality"
              ref="Nacionalidad de la víctima"
              label="Nacionalidad de la víctima"
              menu-props="auto"
            )
          v-flex.pl-2(d-flex xs6)
            v-text-field(
              v-model="country"
              ref="País"
              label="País"
              menu-props="auto"
            )
        v-layout.py-0.my-0(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-text-field(
              v-model="disappearancePlace"
              ref="Último lugar de avistamiento"
              label="Último lugar de avistamiento"
              menu-props="auto"
            )
          v-flex.pl-2(d-flex xs6)
            v-text-field(
              v-model="municipality"
              ref="Municipio"
              label="Municipio"
              menu-props="auto"
            )
        v-layout.py-0.my-0(row wrap align-end justify-space-between)
          v-flex.pr-4(d-flex xs2)
            v-text-field(
              v-model="age"
              ref="Edad"
              label="Edad"
              menu-props="auto"
            )
          v-flex(d-flex xs5)
            v-menu(
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              max-width="290px"
              )
              template(
                slot="activator"
              )
                v-text-field(
                  :value="dateFormattedMomentjs(lastSeenDate)"
                  label="Fecha de último avistamiento"
                  readonly
                )
              v-date-picker(v-model="lastSeenDate" @input="menu1 = false" color="grey lighten-2")

          v-flex(d-flex xs4)
            v-select(
              :items="victimStatuses"
              ref="Estatus de localización"
              v-model="victimStatus"
              label="Estatus de localización"
            )
        v-layout.py-0.my-0(row wrap align-end justify-space-between)
          v-text-field(
            v-model="physicalDescription"
            label="Descripción física"
            :value="physicalDescription"
            multi-line
          )

        v-layout.py-0.my-0(row wrap align-end justify-space-between)
          v-text-field(
            v-model="factDescription"
            label="Descripción de los hechos"
            :value="factDescription"
            multi-line
          )

        v-layout.py-0.my-0.remove.upload(row wrap align-end justify-end)
          v-icon.red-text cancel
          p.small.underline.red-text(@click="removeVictim()") Eliminar víctima

</template>

<script>
import $mx from "../../services/mx.service.js";
import moment from "moment";

export default {
  name: "victim",
  props: ['victimData'],
  data() {
    return {
      menu1: false,
      victimStatuses: ["Aún sin localizar", "Localizado(a) con vida", "Localizado (a) sin vida"],
    };
  },
  computed: {
    photo: {
      get() {
        return this.victimData.photo;
      },
      set(value) {
        this.$store.commit("updatePhoto", {folio: this.victimData.victimFolio, prop: 'photo', val: value});
      }
    },
    victimName: {
      get() {
        return this.victimData.victimName;
      },
      set(value) {
        this.$store.commit("updateVictimName", {folio: this.victimData.victimFolio, prop: 'victimName', val: value});
      }
    },
    victimNationality: {
      get() {
        return this.victimData.nationality;
      },
      set(value) {
        this.$store.commit("updateVictimNationality", {folio: this.victimData.victimFolio, prop: 'nationality', val: value});
      }
    },
    country: {
      get() {
        return this.victimData.country;
      },
      set(value) {
        this.$store.commit("updateVictimCountry", {folio: this.victimData.victimFolio, prop: 'country', val: value});
      }
    },
    disappearancePlace: {
      get() {
        return this.victimData.disappearancePlace;
      },
      set(value) {
        this.$store.commit("updateDisappearancePlace", {folio: this.victimData.victimFolio, prop: 'disappearancePlace', val: value});
      }
    },
    municipality: {
      get() {
        return this.victimData.municipality;
      },
      set(value) {
        this.$store.commit("updateVictimMunicipality", {folio: this.victimData.victimFolio, prop: 'municipality', val: value});
      }
    },
    age: {
      get() {
        return this.victimData.age;
      },
      set(value) {
        if (isNaN(value)) {
          this.$store.commit("updateVictimAge", {folio: this.victimData.victimFolio, prop: 'age', val: ''});
        } else {
          this.$store.commit("updateVictimAge", {folio: this.victimData.victimFolio, prop: 'age', val: parseInt(value)});
        }
      }
    },
    lastSeenDate: {
      get() {
        return this.victimData.lastSeenDate;
      },
      set(value) {
        this.$store.commit("updateLastSeenDate", {folio: this.victimData.victimFolio, prop: 'lastSeenDate', val: value});
      }
    },
    victimStatus: {
      get() {
        return this.victimData.status;
      },
      set(value) {
        this.$store.commit(
          "updateVictimStatus",
          {
            folio: this.victimData.victimFolio,
            prop: 'status',
            val: value
          }
        );
      }
    },
    physicalDescription: {
      get() {
        return this.victimData.physicalDescription;
      },
      set(value) {
        this.$store.commit("updatePhysicalDescription", {folio: this.victimData.victimFolio, prop: 'physicalDescription', val: value});
      }
    },
    factDescription: {
      get() {
        return this.victimData.factDescription;
      },
      set(value) {
        this.$store.commit("updateFactDescription", {folio: this.victimData.victimFolio, prop: 'factDescription', val: value});
      }
    }
  },
  methods: {
    dateFormattedMomentjs(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    },
    pickFile() {
      this.$refs.image.click();
    },
    uploadPicture(e) {
      let pictureName = e.target.files[0].name;

      this.getBase64(e.target.files[0]).then(fileData => {
        this.photo = fileData;
        let pictureData = {
          folio: '',
          file: fileData,
          descrip: 'victima',
          fileName: pictureName
        };
        this.$store
            .dispatch("uploadPicture", {data: pictureData, victimFolio: this.victimData.victimFolio});
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    deletePhoto() {
      this.photo = '';
    },
    removeVictim() {
      this.$store.commit("updateVictims", {
        operation: 'subtract',
        currentFolio: this.victimData.victimFolio
      });
    }
  }
};
</script>

<style scoped lang="scss">
.grey-container {
  background-color: #efefef;
}
.input-group.input-group--dirty.input-group--required.input-group--text-field.primary--text {
  width: 150px;
}

.upload {
  display: flex;
  align-self: center;
  cursor: pointer;
  p {
    font-size: 0.8rem !important;
  }
  &:hover {
    opacity: 0.7;
  }
}

.remove {
  align-items: center;
  i {
    max-width: 30px;
    font-size: 15px;
  }
  .red-text {
    color: #B71C1C !important;
  }
}

.top-col {
  align-self: flex-start;
}

.checkbox-title p {
  font-size: 12px !important;
  color: rgba(0,0,0,.54) !important;
}

.input-group label {
  font-size: 12px !important;
}
input::placeholder {
  font-size: 12px !important;
}
</style>
